import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-hot-toast';
import { FiArrowLeft } from 'react-icons/fi';
import { getArticleById, updateArticle } from '../../../services/firebase/blogService';
import { useAuthState } from 'react-firebase-hooks/auth';
import { auth } from '../../../services/firebase/config';
import ArticleForm from '../../components/ArticleForm';

const EditArticle = () => {
  const { id } = useParams();
  const [article, setArticle] = useState(null);
  const [loading, setLoading] = useState(false);
  const [initialLoading, setInitialLoading] = useState(true);
  const [user] = useAuthState(auth);
  const navigate = useNavigate();

  // Makaleyi yükle
  useEffect(() => {
    const loadArticle = async () => {
      if (!id || !user) return;

      try {
        setInitialLoading(true);
        const articleData = await getArticleById(id);
        setArticle(articleData);
      } catch (error) {
        console.error('Makale yüklenirken hata:', error);
        toast.error('Makale yüklenirken bir hata oluştu');
        navigate('/admin/blog');
      } finally {
        setInitialLoading(false);
      }
    };

    loadArticle();
  }, [id, user, navigate]);

  // Makale güncelleme
  const handleSubmit = async (formData) => {
    if (!user || !id) {
      toast.error('Önce giriş yapmalısınız');
      return;
    }

    try {
      setLoading(true);
      await updateArticle(id, formData);
      toast.success('Makale başarıyla güncellendi');
      navigate('/admin/blog');
    } catch (error) {
      console.error('Makale güncellenirken hata:', error);
      toast.error('Makale güncellenirken bir hata oluştu');
    } finally {
      setLoading(false);
    }
  };

  if (initialLoading) {
    return (
      <div className="container mx-auto px-4 py-8 flex justify-center items-center h-64">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500"></div>
      </div>
    );
  }

  if (!article) {
    return (
      <div className="container mx-auto px-4 py-8">
        <div className="bg-red-50 dark:bg-red-900 border border-red-200 dark:border-red-800 p-4 rounded-md">
          <p className="text-red-700 dark:text-red-200">
            Makale bulunamadı veya erişim izniniz yok.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="container mx-auto px-4 py-8">
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-2xl font-bold text-gray-800 dark:text-white">Makaleyi Düzenle</h1>
        <button
          onClick={() => navigate('/admin/blog')}
          className="flex items-center text-gray-600 hover:text-gray-900 dark:text-gray-300 dark:hover:text-white"
        >
          <FiArrowLeft className="mr-2" />
          Listeye Dön
        </button>
      </div>

      <div className="bg-white dark:bg-gray-800 shadow rounded-lg p-6">
        <ArticleForm 
          initialData={article} 
          onSubmit={handleSubmit} 
          isLoading={loading} 
        />
      </div>
    </div>
  );
};

export default EditArticle;